import CheckoutModal from './CheckoutModal';

export default CheckoutModal;
